require('normalize.css/normalize.css');
require('styles/App.less');
import React, {
  Component,
  PropTypes
} from 'react';
import { Link } from 'react-router'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../actions/const';
import classnames from 'classnames'
import $ from 'jquery'

let config = require('config');

let logo = require('../images/uoc.png')

var browser = {
  ua:null,
  init:function()
  {
    this.ua = navigator.userAgent.toLowerCase();
    this.ua = {
      isLtIE9   : document.uniqueID && typeof window.matchMedia == 'undefined',
      isIE      : document.uniqueID,
      isChrome  : /chrome/.test(this.ua),
      isMobile  : /mobile/.test(this.ua),
      isIOS     : /i(phone|pod|pad)/.test(this.ua),
      isAndroid : /android/.test(this.ua)
    }
  },
  isMobile:function()
  {
    if (this.ua.isIOS || this.ua.isAndroid || this.ua.isMobile) return true;
    else false;
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    browser.init()
    if (browser.isMobile()) {
      $("html").addClass("mobile");
    }
    this.state = {
    }
  }
  componentDidMount() {
    const { actions, params, route } = this.props;
    actions.getPosts()
  }
  render() {
    const {actions, data, children} = this.props;
    document.title = config.default.SITE_NAME
    return (
      <div id="container">
        <header>
          <h1><Link to="/">ポストコロナプロトタイプ｜Creativityになにができるか</Link></h1>
          <div className="fixed_logo"><img src={logo} alt="UNIVERSITY of CREATIVITY"/></div>
        </header>
        <div id="content">{children}</div>
      </div>
    )
  }
}

App.propTypes = {
  actions: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const props = {
    data:state.data
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  const actionMap = { actions: bindActionCreators(actions, dispatch) };
  return actionMap;
}
export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App.js